<div class="container" fxLayout="row" fxLayoutAlign="center center">
  <div *ngIf="myloading" class="loading-overlay">
    <lib-page-loader [loading]="myloading"></lib-page-loader>
  </div>

  <div
    class="m-t-25"
    style="margin-top: 0px !important"
    fxLayout="row"
    fxLayoutAlign="center center"
    [ngClass]="{ 'hidden-content': myloading }"
  >
    <mat-card class="m-t-25 mat-elevation-z8 custom-bg">
      <div fxLayout="row" fxLayout.lt-md="column" class="div-informacion">
        <div class="p-25" fxFlex="40%" fxLayout="column">
          <div>
            <div *ngIf="!nombreDepartamento" class="font-bold">
              Información a Nivel Nacional
            </div>
            <div *ngIf="!nombreDepartamento">
              Selecciona el departamento de tu interés
            </div>
            <div *ngIf="nombreDepartamento" class="font-bold">
              Información en {{ nombreDepartamento }}
            </div>
          </div>
          <div class="m-t-25">
            <div
              id="chart"
              #chartElement
              style="height: 550px; width: 100%"
            ></div>
            <div class="text-center m-t-25">
              <button mat-button (click)="handleClickInfoNacional()">
                <mat-icon>place</mat-icon>
                Mostrar información nacional
              </button>
            </div>
          </div>
        </div>

        <div
          class="position-relative div-datos-principales"
          fxFlex="100%"
          fxLayoutAlign="center center"
        >
          <div class="no-padding">
            <div fxLayout="column" class="fullwidth">
              <div fxLayout="row" fxLayout.lt-md="column">
                <div
                  class="contenedor-informacion custom-bg2 border-vertical-gray"
                  fxLayout="column"
                  fxFlex="50%"
                  fxLayoutAlign="flex-end center"
                >
                  <div fxLayout="column" fxLayoutAlign="center center">
                    <img
                      class="icon-informacion"
                      src="/assets/img/web/principal/icono_universidades.svg"
                    />

                    <div class="contadores-contenedor">
                      <div
                        class="p-l-5 descripcion-contador text-naranja-sunedu font-bold text-center"
                      >
                        {{ cantidadUniversidades$ | async }}
                      </div>
                      <div
                        class="p-l-5 descripcion-categoria font-bold text-center"
                      >
                        instituciones de educación superior universitaria
                      </div>
                    </div>
                  </div>

                  <div fxLayout="column" fxLayoutAlign="center center">
                    <div class="info-resumen">
                      Licenciadas de gestión pública y privada
                    </div>
                    <div>
                      <button
                        mat-flat-button
                        type="button"
                        class="btn-ir-categoria rounded-full bg-naranja-sunedu hover-azul-sunedu"
                        (click)="handleOpenFiltroUniversidades()"
                      >
                        Ver universidades
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Programas - Inicio -->
                <!-- 
                      <div
                        class="contenedor-informacion"
                        ngClass.gt-sm="border-vertical-gray"
                        fxLayout="column"
                        fxFlex="50%"
                        fxLayoutAlign="flex-end center">

                        <div
                          fxLayout="column"
                          fxLayoutAlign="center center">
                          <img
                            class="icon-informacion"
                            src="/assets/img/web/principal/icono_programas.svg">

                          <div class="contadores-contenedor">
                            <div
                              class="p-l-5 descripcion-categoria font-bold text-center"
                              *ngIf="ubigeoSelected == null">
                              Más de
                            </div>
                            <div
                              class="p-l-5 descripcion-contador text-verde-sunedu font-bold text-center h-10"
                              *ngIf="ubigeoSelected == null">
                              7 mil
                            </div>
                            <div
                              class="p-l-5 descripcion-contador text-verde-sunedu font-bold text-center h-10"
                              *ngIf="ubigeoSelected != null">
                              {{cantidadCarreras$ | async}}
                            </div>
                            <div class="p-l-5 descripcion-categoria font-bold text-center">
                              programas ofertados en los locales de estudio
                            </div>
                          </div>
                        </div>

                        <div
                          fxLayout="column"
                          fxLayoutAlign="center center">
                          <div class="info-resumen">
                            Para niveles pregrado, segunda especialidad, maestría y doctorado
                          </div>
                          <div>
                            <button
                              mat-flat-button
                              type="button"
                              class="btn-ir-categoria rounded-full bg-verde-sunedu hover-azul-sunedu"
                              (click)="handleOpenFiltroCarrera()">
                              Ver programas
                            </button>
                          </div>
                        </div>

                      </div>
                        -->
                <!-- Programas - Fin-->

                <!-- Postulantes - Inicio -->

                <div
                  class="contenedor-informacion"
                  ngClass.gt-sm="border-vertical-gray"
                  fxLayout="column"
                  fxFlex="50%"
                  fxLayoutAlign="flex-end center"
                >
                  <div fxLayout="column" fxLayoutAlign="center center">
                    <img
                      class="icon-informacion"
                      src="/assets/img/web/principal/personas.svg"
                    />

                    <div class="contadores-contenedor">
                      <div
                        class="p-l-5 descripcion-categoria font-bold text-center"
                        *ngIf="ubigeoSelected == null"
                      >
                        Más de
                      </div>
                      <div
                        class="p-l-5 descripcion-contador text-verde-sunedu font-bold text-center h-10"
                        *ngIf="ubigeoSelected == null"
                      >
                        870 mil
                      </div>
                      <div
                        class="p-l-5 descripcion-contador text-verde-sunedu font-bold text-center h-10"
                        *ngIf="ubigeoSelected != null"
                      >
                        {{ cantidadPostulantes$ | async }}
                      </div>
                      <div
                        class="p-l-5 descripcion-categoria font-bold text-center"
                      >
                        postulantes
                      </div>
                    </div>
                  </div>

                  <div fxLayout="column" fxLayoutAlign="center center">
                    <div class="info-resumen">
                      En universidades licenciadas públicas y privadas, año
                      {{ varAnioCurso }}
                    </div>
                    <div>
                      <button
                        mat-flat-button
                        type="button"
                        class="btn-ir-categoria rounded-full bg-verde-sunedu hover-azul-sunedu"
                        (click)="handleOpenFiltroEstudiantePostulantes()"
                      >
                        Ver Postulantes
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Postulantes - Fin-->
              </div>

              <div fxLayout="row" fxLayout.lt-md="column">
                <!-- <div
            fxFlex="1 1 auto"
            fxLayoutAlign="center center">
            3
          </div>

          <div
            fxFlex="1 1 auto"
            fxLayoutAlign="center center">
            4
          </div> -->

                <div
                  class="contenedor-informacion border-vertical-gray"
                  ngClass.gt-sm="border-horizontal-gray"
                  fxLayout="column"
                  [fxFlex]="nombreDepartamento ? '100%' : '50%'"
                  fxLayoutAlign="flex-end center"
                >
                  <div fxLayout="column" fxLayoutAlign="center center">
                    <img
                      class="icon-informacion"
                      src="/assets/img/web/principal/icono-comunidad.svg"
                    />

                    <div class="contadores-contenedor">
                      <div
                        class="p-l-5 descripcion-categoria font-bold text-center"
                        *ngIf="ubigeoSelected == null"
                      >
                        Más de
                      </div>
                      <div
                        class="p-l-5 descripcion-contador text-amarillo-sunedu font-bold text-center"
                        *ngIf="ubigeoSelected == null"
                      >
                        1.3 millones
                      </div>
                      <div
                        class="p-l-5 descripcion-categoria font-bold text-center"
                        *ngIf="ubigeoSelected == null"
                      >
                        de estudiantes
                      </div>
                      <div
                        class="p-l-5 descripcion-contador text-amarillo-sunedu font-bold text-center"
                        *ngIf="ubigeoSelected != null"
                      >
                        {{ cantidadEstudiantes$ | async }}
                      </div>
                      <div
                        class="p-l-5 descripcion-categoria font-bold text-center"
                        *ngIf="ubigeoSelected != null"
                      >
                        estudiantes de pregrado
                      </div>
                    </div>
                  </div>

                  <div fxLayout="column" fxLayoutAlign="center center">
                    <div class="info-resumen">
                      <!-- En universidades licenciadas públicas y privadas, periodo {{varAnioCurso + '-' + varPeriodoCurso}} -->
                      En universidades licenciadas públicas y privadas, periodo
                      {{ varAnioCurso + "-II" }}
                    </div>
                    <div>
                      <button
                        mat-flat-button
                        type="button"
                        class="btn-ir-categoria rounded-full bg-amarillo-sunedu hover-azul-sunedu"
                        (click)="handleOpenFiltroEstudiantes()"
                      >
                        Ver comunidad estudiantil
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="!nombreDepartamento"
                  class="contenedor-informacion custom-bg2"
                  ngClass.gt-sm="border-vertical-gray border-horizontal-gray"
                  fxLayout="column"
                  fxFlex="50%"
                  fxLayoutAlign="flex-end center"
                >
                  <div fxLayout="column" fxLayoutAlign="center center">
                    <img
                      class="icon-informacion"
                      src="/assets/img/web/principal/icono-docentes.svg"
                    />

                    <div class="contadores-contenedor">
                      <div
                        class="p-l-5 descripcion-categoria font-bold text-center"
                      >
                        Más de
                      </div>
                      <div
                        class="p-l-5 descripcion-contador text-azul-sunedu font-bold text-center"
                        *ngIf="ubigeoSelected == null"
                      >
                        63 mil
                      </div>
                      <div
                        class="p-l-5 descripcion-contador text-azul-sunedu font-bold text-center"
                        *ngIf="ubigeoSelected != null"
                      >
                        {{ cantidadDocentes$ | async }}
                      </div>
                      <div
                        class="p-l-5 descripcion-categoria font-bold text-center"
                      >
                        docentes
                      </div>
                    </div>
                  </div>

                  <div fxLayout="column" fxLayoutAlign="center center">
                    <div class="info-resumen">
                      <!-- En universidades licenciadas públicas y privadas, periodo {{varAnioCurso + '-' + varPeriodoCurso}} -->
                      En universidades licenciadas públicas y privadas, periodo
                      {{ varAnioCurso + "-I" }}
                    </div>
                    <div>
                      <button
                        mat-flat-button
                        type="button"
                        class="btn-ir-categoria rounded-full bg-azul-sunedu hover-gris-sunedu"
                        (click)="handleOpenFiltroDocentes()"
                      >
                        Ver docentes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>
